import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { parseJobsToExpanded, filterDataByDateAndSearch } from '../../../../../../utils/helpers';
import RowSubComponentActiveAsync from '../../components/RowSubComponentActiveAsync';
import TableJobs from '../../components/TableJobs';

const JobsActive = ({ jobs, searchText, refetchJobsActive, onClickEdit, onClickDuplicate, onClickDelete, startDate, endDate }) => {

    const { id } = useParams();

    // If exists id then set active job as first item
    const jobsExpanded = useMemo(
        () => parseJobsToExpanded(jobs, id),
        [jobs, id]
    );

    const jobsFiltered = useMemo(
        () => {
            return filterDataByDateAndSearch(jobsExpanded, searchText, startDate, endDate);
        },
        [jobsExpanded, searchText, startDate, endDate]
    );

    const renderRowSubComponent = useCallback(
        ({ row, rowProps, visibleColumns }) => (
            <RowSubComponentActiveAsync
                row={row}
                rowProps={rowProps}
                visibleColumns={visibleColumns}
                refetchJobsActive={refetchJobsActive}
                onClickEdit={onClickEdit}
                onClickDuplicate={onClickDuplicate}
                onClickDelete={onClickDelete}
            />
        ),
        [refetchJobsActive, onClickEdit, onClickDuplicate, onClickDelete]
    );

    return (
        <TableJobs
            jobs={jobsFiltered}
            renderRowSubComponent={renderRowSubComponent}
        />
    )
}

export default JobsActive;
